import { Input } from '../';

export const TelInput = (props) => <Input {...props} type="tel" maxLength="15" />;
